export const MUNICIPALITY = "municipality";
export const COUNTY = "county";
export const ZIP = "zip";
export const CUSTOM_FILTER = "city_area";
export const FOREIGN_GEO_CITY = "predefined_city";
export const FOREIGN_GEO_PROVINCE = "predefined_areas";
export const FOREIGN_GEO_AREA = "predefined_province";
